/* globals $ */

/**
 * class for the handling show on scroll actions
 */
class ShowOnScroll {
  init() {
    if (typeof $ === 'undefined') return;
    $(window).scroll(this.transitionScrollHandler.bind(this));
    $(document).ready(this.transitionScrollHandler.bind(this));

    // scroll reveal
    this.$scrollItems = [];
    $('.transition-item').each((i, val) => {
      const $val = $(val);

      // All items start with active to allow showing if js is disabled
      // remove the active classes on items below the fold
      if ((window.scrollY + window.innerHeight) <= $val.offset().top) {
        $val.removeClass('active');
      }

      // add transition items to the scroll items array
      this.$scrollItems.push($val);
    });
  }

  /**
   * Handler for scroll reveal transition animations
   */
  transitionScrollHandler() {
    let i = 0;
    while (i < this.$scrollItems.length && (window.scrollY + window.innerHeight) >= this.$scrollItems[i].offset().top) {
      this.$scrollItems[i].addClass('active');
      i += 1;
    }
  }
}

export default ShowOnScroll;
